import { render, staticRenderFns } from "./filter-sidebar.vue?vue&type=template&id=1008af86&"
import script from "./filter-sidebar.vue?vue&type=script&lang=js&"
export * from "./filter-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports